/**
 * Centralized DEV_MODE flag.
 * Set to `false` before going to production to re-enable
 * authentication, onboarding gates, and trial checks.
 */
export const DEV_MODE = false;
